import React, { Component } from 'react';

import { ModalImage } from "./ModalImage";
import { EmailSignup } from "./EmailSignup";
import { BookPrivateTourButton } from "./BookPrivateTourButton";
import { Mixpanel } from './Mixpanel';

import settings from '../data/settings_khufu_ar.json';


interface Props {
  point: any;
  onClicked?: () => void | null;
}

interface State {
  modalVisible: boolean;
}


// handle revealing and hiding text at mapped frame indexes
const _handleScrolltext = (index) => {
  const tour_points = [];// tourpoints.payload.objects;
  let text_elem;

  tour_points.forEach((tour_point, i) => {
    if (index < tour_point.show) {
      text_elem = document.getElementById(`text${i}`);
      if (text_elem) {
        text_elem.classList.remove("scroll-text-post");
        text_elem.classList.remove("scroll-text-active");
        text_elem.classList.add("scroll-text-pre");
        text_elem.classList.remove("scroll-text-pre");
        text_elem.classList.add("scroll-text-hidden");
      }
    } else if (index > tour_point.hide) {
      text_elem = document.getElementById(`text${i}`);
      if (text_elem) {
        text_elem.classList.remove("scroll-text-pre");
        text_elem.classList.remove("scroll-text-active");
        text_elem.classList.add("scroll-text-post");
        text_elem.classList.remove("scroll-text-post");
        text_elem.classList.add("scroll-text-hidden");
      }
    }

    if (index > tour_point.show && index < tour_point.hide) {
      // switch to a new tourpoint
      text_elem = document.getElementById(`text${i}`);
      if (text_elem) {
        text_elem.classList.remove("scroll-text-hidden");
        text_elem.classList.add("scroll-text-pre");
        text_elem.classList.remove("scroll-text-pre");
        text_elem.classList.add("scroll-text-active");
        text_elem.classList.remove("scroll-text-post");
      }

    }
  });
}

export class TourPointText extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      modalVisible: false,
    };

    this.handleImgClick = this.handleImgClick.bind(this);
    this.showModalImage = this.showModalImage.bind(this);
    this.hideModalImage = this.hideModalImage.bind(this);
    this.makeImageSrc = this.makeImageSrc.bind(this);
  }

  handleImgClick(e) {
    const { point } = this.props;
    console.log("handleImgClick")

    Mixpanel.track('User clicked an image in a Guided tour step', {
      "image": point.image,
    });

    this.showModalImage();
  }

  showModalImage() {
    console.log("show modal image")
    this.setState({
      modalVisible: true,
    });
  }

  hideModalImage() {
    this.setState({
      modalVisible: false,
    });
  }

  makeImageSrc() {
    const { point } = this.props;
    let img_src = null;

    if (typeof point.image !== "undefined" && point.image.length) {
      if (point.image.indexOf(".gif") >= 0) {
        img_src = `https://static.mused.org/${point.image}`;
      } else {
        img_src = `https://iiif.mused.org/${point.image}/square/600,/0/default.jpg`;
      }
    }

    return img_src;
  }

  makeVideoSrc() {
    const { point } = this.props;
    let video_src = null;

    if (typeof point.video !== "undefined" && point.video.length) {
      video_src = `https://static.mused.org/${point.video}`;
    }

    return video_src;
  }

  render() {
    const { point } = this.props;
    const { modalVisible } = this.state;
    let maxWidth = "30rem";

    let position = "right-0 left-0 sm:left-auto w-full sm:w-auto lg:w-128 ";
    if (point.position === "center") {
      position = "right-auto left-auto w-full text-center";
      maxWidth = "none";
    } else if (point.position === "left") {
      position = "right-0 sm:right-auto left-0 w-full sm:w-auto lg:w-128 ";
    }

    if (settings.language && settings.language === "ar" && point.position !== "center") {
      console.log('settings', settings.language);
      position += " text-right";
    } else {
      position += " text-left";
    }


    return (
      <div>
        <div
          className={`tour-point-content fixed ${position} text-white z-50 bottom-32 sm:bottom-32 pointer-events-none ${point.className || ""} `}
          onClick={this.props.onClicked||null}
          style={{
            maxWidth,
            background: point.background,
          }}
        >
          {point.includeEmailSignup ?
            <EmailSignup />
          : ''}
          <div className={` flex flex-col items-start ${point.position == "right" ? 'sm:items-end' : ''}`}>
            {point.image ?
              <img src={this.makeImageSrc()} className={`w-20 h-20 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-52 lg:h-52 object-cover mb-2 mx-6 shadow-xl object-center rounded-lg cursor-zoom-in pointer-events-auto`} onClick={this.handleImgClick.bind(this)} />
            : ''}
            {point.video ?
              <video src={this.makeVideoSrc()} className={`w-auto h-20 sm:h-32 md:h-40 lg:h-52 object-contain mb-2 max-w-3xl mx-6  shadow-xl object-center rounded-lg cursor-zoom-in pointer-events-auto`} controls autoPlay style={{ maxWidth: "28rem" }} />
            : ''}
            <p className={`block p-6 font-sans text-xl ${point.position == "center" ? "sm:text-3xl" : "sm:text-2xl"} max-w-3xl mx-auto`} dangerouslySetInnerHTML={{ __html: point.content }} style={{
              textShadow: "0px 0px 5px #000",
              background: point.textBackground,
            }}></p>

            {point.includeBookPrivate ?
              <BookPrivateTourButton />
            : ''}
          </div>
        </div>

        {modalVisible && point.image ? <ModalImage hideModalImage={this.hideModalImage} filename={point.image} /> : ''}
        <div className="hidden pt-2 sm:pt-8 pt-4 pt-6 pb-4 pb-6"></div>
      </div>
    );
  }
}
